import { useEffect, useRef } from "react";
import { Device } from "@capacitor/device";
import { httpsCallable } from "firebase/functions";
import { functionsAsia } from "@/lib/firebase";
import { useAuth } from "./use-auth";

const HEARTBEAT_MS = 15 * 60 * 1000; // 15 min

export function useDeviceRegister() {
  const { user } = useAuth();
  const deviceIdRef = useRef<string | null>(null);
  const heartbeatRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!user) {
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      return;
    }

    (async () => {
      try {
        const info = await Device.getId();
        const deviceInfo = await Device.getInfo();
        const deviceId = info.identifier;
        deviceIdRef.current = deviceId;
        try {
          localStorage.setItem("dh_mobile_device_id", deviceId);
        } catch {}
        const label = `${deviceInfo.manufacturer || ""} ${deviceInfo.model || "Mobile"}`.trim() || "Mobile device";

        const register = httpsCallable(functionsAsia, "registerDevice");
        const res = await register({ deviceId, type: "mobile", label });
        const data = res.data as { ok: boolean; reason?: string; activeDevices?: any[] };
        if (!data.ok) {
          console.warn("[device] registration blocked:", data.reason);
        }

        // Heartbeat every 15 min while app active
        heartbeatRef.current = setInterval(async () => {
          try {
            const beat = httpsCallable(functionsAsia, "deviceHeartbeat");
            await beat({ deviceId });
          } catch (err) {
            console.warn("[device] heartbeat failed:", err);
          }
        }, HEARTBEAT_MS);
      } catch (err) {
        console.warn("[device] register failed:", err);
      }
    })();

    return () => {
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
    };
  }, [user]);

  return deviceIdRef.current;
}
